import script from "./FinishReset.vue?vue&type=script&setup=true&lang=js"
export * from "./FinishReset.vue?vue&type=script&setup=true&lang=js"

import "./FinishReset.vue?vue&type=style&index=0&id=23d4c5e5&lang=css"

const __exports__ = script;

export default __exports__